import EmptyState from 'components/EmptyState/EmptyState';
import { dateToEpoch } from 'helper/helper';
import UseContext from 'hooks/useContext';
import { useEffect, useState } from 'react';
import PlanningDateSection from './planningDateSection';
import { timeSheets } from './planningUtils';
import ScheduleToggleSection from './scheduleToggleSection';
import ScheduleWeeksSection from './ScheduleWeeksSection';

const SlideOverAddMissionPlanning = () => {
  const {
    dataCreateMission,
    setDataCreateMission,
    updSchedule,
    setUpdSchedule,
  } = UseContext();

  const [scheduleWeeks, setScheduleWeeks] = useState([]);
  const [scheduleWeekDisplay, setScheduleWeekDisplay] = useState(0);
  const [isScheduleChecked, setIsScheduleChecked] = useState(
    dataCreateMission.isScheduleCheck || false
  );
  const [error, setError] = useState(false);
  const [error1, setError1] = useState(false);

  const validateDates = (start, end) => {
    if (start && end) {
      const startEpoch = dateToEpoch(new Date(start));
      const endEpoch = dateToEpoch(new Date(end));
      const invalid = startEpoch > endEpoch;
      setError(invalid);
      setError1(invalid);
    } else {
      setError(false);
      setError1(false);
    }
  };

  // Generate weeks and group days
  useEffect(() => {
    if (dataCreateMission.schedule.length === 0) {
      if (dataCreateMission.dateStart && dataCreateMission.dateEnd) {
        const startEpoch = dateToEpoch(new Date(dataCreateMission.dateStart));
        const endEpoch = dateToEpoch(new Date(dataCreateMission.dateEnd));

        if (startEpoch > endEpoch) {
          setError(true);
          setError1(true);
          setScheduleWeeks([]);
          dataCreateMission.schedule = [];
          return;
        } else {
          setError(false);
          setError1(false);
        }

        const rawWeeks = timeSheets(startEpoch, endEpoch);

        const daysArray = rawWeeks.map((weekArr, i) =>
          weekArr.map((dayEpoch) => ({ date: dayEpoch, week: i }))
        );

        // Merge adjacent small weeks into one if combined length ≤ 7
        const merged = [];
        const skip = new Set();
        daysArray.forEach((weekDays, i) => {
          if (skip.has(i)) return;
          const next = daysArray[i + 1];
          if (next && weekDays.length + next.length <= 7) {
            merged.push({
              name: `Semaine ${('0' + (i + 1)).slice(-2)} & ${(
                '0' +
                (i + 2)
              ).slice(-2)}`,
              days: [...weekDays, ...next],
            });
            skip.add(i + 1);
          } else {
            merged.push({
              name: `Semaine ${('0' + (i + 1)).slice(-2)}`,
              days: weekDays,
            });
          }
        });

        setScheduleWeeks(merged);
        dataCreateMission.schedule = merged;
      }
    } else {
      setScheduleWeeks(dataCreateMission.schedule);
    }
    setUpdSchedule(false);
  }, [dataCreateMission, updSchedule]);

  // Sync back to context
  useEffect(() => {
    if (scheduleWeeks.length > 0) {
      setDataCreateMission({ ...dataCreateMission, schedule: scheduleWeeks });
    }
  }, [scheduleWeeks, updSchedule]);

  // Update schedule check flag
  useEffect(() => {
    setDataCreateMission({
      ...dataCreateMission,
      isScheduleCheck: isScheduleChecked,
    });
  }, [isScheduleChecked]);

  const handleDateStart = (date) => {
    if (dateToEpoch(dataCreateMission.dateStart) !== dateToEpoch(date)) {
      setDataCreateMission((prev) => ({
        ...prev,
        schedule: [],
        isConfirmedSchedule: false,
      }));
    }
    const sameDay =
      dataCreateMission.dateEnd &&
      dateToEpoch(date) === dateToEpoch(dataCreateMission.dateEnd);

    validateDates(date, dataCreateMission.dateEnd);

    setDataCreateMission((prev) => ({
      ...prev,
      dateStart: date,
      isScheduleCheck: true,
      isScheduleRequired: sameDay,
    }));
  };

  const handleDateEnd = (date) => {
    if (dateToEpoch(dataCreateMission.dateEnd) !== dateToEpoch(date)) {
      setDataCreateMission((prev) => ({
        ...prev,
        schedule: [],
        isConfirmedSchedule: false,
      }));
    }
    const sameDay =
      dataCreateMission.dateStart &&
      dateToEpoch(date) === dateToEpoch(dataCreateMission.dateStart);

    validateDates(dataCreateMission.dateStart, date);

    setDataCreateMission((prev) => ({
      ...prev,
      dateEnd: date,
      isScheduleCheck: true,
      isScheduleRequired: sameDay,
    }));
  };

  return (
    <div className="flex flex-col gap-4">
      <PlanningDateSection
        dataCreateMission={dataCreateMission}
        handleDateStart={handleDateStart}
        handleDateEnd={handleDateEnd}
        error1={error1}
        error={error}
      />

      {dataCreateMission.dateStart && dataCreateMission.dateEnd ? (
        <>
          <div className="flex justify-between">
            <div className="ft-xl text-gray-900 font-medium my-auto">
              Planning
            </div>
            <ScheduleToggleSection
              isScheduleChecked={isScheduleChecked}
              setIsScheduleChecked={setIsScheduleChecked}
              isScheduleRequired={dataCreateMission.isScheduleRequired}
            />
          </div>
          <ScheduleWeeksSection
            scheduleWeeks={scheduleWeeks}
            scheduleWeekDisplay={scheduleWeekDisplay}
            setScheduleWeekDisplay={setScheduleWeekDisplay}
            isScheduleChecked={isScheduleChecked}
            isScheduleRequired={dataCreateMission.isScheduleRequired}
          />
        </>
      ) : (
        <EmptyState type="schedule_missing_periods" compact />
      )}
    </div>
  );
};

export default SlideOverAddMissionPlanning;
